export default __webpack_public_path__ + "static/media/rocket-dialog.fddb9be5.svg";